import { ReadonlyURLSearchParams } from 'next/navigation';

export const getSelectedMonths = (searchParams: ReadonlyURLSearchParams) => {
  const params = searchParams.get('selectedMonths');
  if (params) return params.split(',').map(Number);
  return [];
};
